<template>
<div class="c-step finish">
  <h1> Dziękujemy za wypełnienie ankiety.
    <br>
    Nasz dział logistyki weryfikuje otrzymane informacje.</h1>


</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import {
  mapMutations,
  mapActions
} from 'vuex'

export default {
  name: 'finish',
  computed: {
    answers: {
      get() {
        return this.$store.state.answers
      },
      set(state, payload) {
        this.$store.commit('setAnswers', payload)
      }
    }
  },
  methods:{
    ...mapActions(['submitAnswer'])
  },
  mounted(){
    this.submitAnswer();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1 {
    font-size: 1.5rem;
    width: 100%;
    text-align: center;
}
</style>
